var _excluded = ["min", "max", "value", "isIndeterminate"],
  _excluded2 = ["value", "min", "max", "hasStripe", "isAnimated", "children", "className", "borderRadius", "isIndeterminate", "aria-label", "aria-labelledby"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, omitThemingProps, StylesProvider, useMultiStyleConfig, useStyles } from '../../system';
import { __DEV__, cx } from '../../utils';
import * as React from 'react';
import { getProgressProps, progress, stripe } from './progress.utils';
/**
 * ProgressFilledTrack
 *
 * The progress component that visually indicates the current level of the progress bar.
 * It applies `background-color` and changes its width.
 */
var ProgressFilledTrack = props => {
  var {
      min,
      max,
      value,
      isIndeterminate
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var progress = getProgressProps({
    value,
    min,
    max,
    isIndeterminate
  });
  var styles = useStyles();
  var trackStyles = _objectSpread({
    height: '100%'
  }, styles.filledTrack);
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    style: _objectSpread({
      width: "".concat(progress.percent, "%")
    }, rest.style)
  }, progress.bind, rest, {
    __css: trackStyles
  }));
};
/**
 * Progress is used to display the progress status for a task that takes a long
 * time or consists of several steps.
 *
 * It includes accessible attributes to help assistive technologies understand
 * and speak the progress values. *
 */
export var Progress = props => {
  var _styles$track;
  var _omitThemingProps = omitThemingProps(props),
    {
      value,
      min = 0,
      max = 100,
      hasStripe,
      isAnimated,
      children,
      className,
      borderRadius: propBorderRadius,
      isIndeterminate,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy
    } = _omitThemingProps,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded2);
  var styles = useMultiStyleConfig('Progress', props);
  var borderRadius = propBorderRadius !== null && propBorderRadius !== void 0 ? propBorderRadius : (_styles$track = styles.track) === null || _styles$track === void 0 ? void 0 : _styles$track.borderRadius;
  var stripAnimation = {
    animation: "".concat(stripe, " 1s linear infinite")
  };

  /**
   * We should not use stripe if it is `indeterminate`
   */
  var shouldAddStripe = !isIndeterminate && hasStripe;
  var shouldAnimateStripe = shouldAddStripe && isAnimated;

  /**
   * Generate styles for stripe and stripe animation
   */
  var css = _objectSpread(_objectSpread({}, shouldAnimateStripe && stripAnimation), isIndeterminate && {
    position: 'absolute',
    willChange: 'left',
    minWidth: '50%',
    animation: "".concat(progress, " 1s ease infinite normal none running")
  });
  var trackStyles = _objectSpread({
    overflow: 'hidden',
    position: 'relative'
  }, styles.track);
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    className: cx('tqc-progress', className),
    borderRadius: borderRadius,
    __css: trackStyles
  }, rest), /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(ProgressFilledTrack, {
    className: "tqc-progress__track",
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    min: min,
    max: max,
    value: value,
    isIndeterminate: isIndeterminate,
    sx: css,
    borderRadius: borderRadius
  }), children));
};
if (__DEV__) {
  Progress.displayName = 'Progress';
}